import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import { useSettings } from "../../context/SettingsContext";
export const useReminder = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-reminder'], queryFn: async ({ signal }) => {
            let url = new URL(`/consumer/booking/reminder`, ConfigHolder.apiBaseUrl);
            url.searchParams.set('email', formContext.getValues('email'));
            url.searchParams.set('key', api_key);
            url.searchParams.set('widget_id', widget_id);
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
